module.exports = __webpack_public_path__ + "img/440a.b35eff60.png";